import {
  ConsentService,
  GetTermsServiceOutput,
  SendConsentServiceOutput,
} from '@core/model/service/consentService';
import { injectable } from 'inversify';

@injectable()
export class IMConsentService implements ConsentService {
  getTerms(): GetTermsServiceOutput {
    throw new Error('Method not implemented.');
  }
  sendConsent(): SendConsentServiceOutput {
    throw new Error('Method not implemented.');
  }
}
